import React from "react";
import { Helmet } from "react-helmet";
import MetaTagContents from "../../MetaTagContents";
import NavBar from "../landingPage/header/navbar";
import HeroSection from "./HeroSection/HeroSection";
import ALL3DBenefits from "./ALL3DBenefits/ALL3DBenefits";
import BrandsCarousel from "../pricingV2/components/BrandsCarousel/BrandsCarousel";
import ALL3DServices from "./ALL3DServices/ALL3DServices";
import SellersWin from "./SellersWin/SellersWin";
import Metrics from "./Metrics/Metrics";
import PremiumContext from "./PremiumContent/PremiumContext";
import BookendSection from "./BookendSection/BookendSection";
import Footer from "../landingPage/footer";
import ComparisonSection from "./ComparisonSection/ComparisonSection";
import HowItWorks from "./HowItWorks/HowItWorks";
import { Layout } from "antd";

const SMBLandingPage = () => {

  const { name, content, schemaMarkup } = MetaTagContents.LANDING_PAGE;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{MetaTagContents.LANDING_PAGE.title}</title>
        <link rel="canonical" href="https://all3d.ai/" />
        <meta name={name} content={content} />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup.video)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup.organization)}
        </script>
      </Helmet>

      <NavBar />
      <Layout style={{ overflowX: "hidden"}}>
        <HeroSection />
        <ALL3DBenefits />
        <BrandsCarousel />
        <ALL3DServices />
        <SellersWin />
        <Metrics />
        <HowItWorks />
        <PremiumContext />
        <ComparisonSection />
        <BookendSection />
      </Layout>
      <Footer />
    </>
  );
}

export default SMBLandingPage;
